import React from 'react';
import { forwardRef } from '@heroui/system';
import { extendVariants, Badge, BadgeProps } from '@heroui/react';

export const CustomBadge = extendVariants(Badge, {
  variants: {
    size: {
      md: {
        badge: 'w-0.5 h-0.5 min-w-0.5 min-h-0.5 p-1',
      },
    },
    variant: {
      faded: {
        badge: 'border border-base-50',
      },
    },
    color: {
      danger: {
        badge: 'bg-red',
      },
    },
  },
  defaultVariants: {
    size: 'md',
    color: 'danger',
    variant: 'faded',
  },
});

export interface CustomBadgeProps extends Omit<BadgeProps, 'ref'> {
  content?: React.ReactNode;
}

const TmdxBadge = forwardRef<'span', CustomBadgeProps>((props, ref) => {
  const { children, content = '', size = 'md', color = 'danger', variant = 'faded', ...restProps } = props;

  return (
    <CustomBadge ref={ref} content={content} size={size} color={color} variant={variant} {...restProps}>
      {children}
    </CustomBadge>
  );
});

TmdxBadge.displayName = 'TmdxBadge';

export default TmdxBadge;
